import { createFileRoute } from '@tanstack/react-router';
import { adminUsers } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { UsersView } from '@/screens/admin-users';

export const Route = createFileRoute('/admin/users')({
  // The API's `require_capability` admits any level above `none`, hence `own`.
  beforeLoad: requireCapability('users_manage', 'own'),
  loader: ({ context }) => warm(context.queryClient, adminUsers({})),
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <UsersView setView={setView} />;
}
